import React from "react";
import { NavLink, useParams } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import MoneyIcon from "@material-ui/icons/Money";
import * as Glob from "src/Globale";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _CommissionsForm, _InfoSection } from "../components";

export interface IRouteParam {
    ID_Binder: string;
}

export const _Commissions: React.FC<Glob.IRouteGlobaleProps> = props => {
    const ID_Binder = useParams<IRouteParam>().ID_Binder;

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={MoneyIcon} Title="Provvigioni" />
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoSection DataUrl={`/api/binder/Contesto?ID_Binder=${ID_Binder}`} LinkUrl={`/binder/${ID_Binder}`} Title="Binder" />
                        </Grid>
                        <Grid item xs={12}>
                            <_CommissionsForm ID_Binder={ID_Binder} />
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/Commissions.tsx